<template>
  <session-gate>
    <router-view />
  </session-gate>

  <confirm-modal />
  <support-modal />
  <offline-banner />
</template>

<script setup>
  import { useHead } from '@unhead/vue'

  import { useMetadataStore } from 'src/stores/account/metadata'

  import SessionGate from 'src/components/auth/SessionGate.vue'
  import ConfirmModal from 'src/components/common/ConfirmModal.vue'
  import OfflineBanner from 'src/components/common/OfflineBanner.vue'
  import SupportModal from 'src/components/common/SupportModal.vue'

  const metadataStore = useMetadataStore()

  useHead(() => metadataStore.metaTags)
</script>
